module.exports = __webpack_public_path__ + "static/media/75.d2361904.png";